<template>
  <van-radio-group v-if="!isInWx" v-model="payType" class="pay-type-box">
    <van-radio name="wx" checked-color="#96c05f">微信</van-radio>
    <van-radio name="ali" checked-color="#009ae2">支付宝</van-radio>
  </van-radio-group>
</template>
<script>
  export default {
    props: {
      value: String
    },
    data() {
      return{
        // wx 微信， ali 支付宝
        payType: this.value,
        isInWx: this.$mdUtils.isWeiXin()
      }
    },
    watch: {
      payType(val) {
        this.$emit('input', val)
      }
    }
  };
</script>
<style lang='scss' scoped>
.pay-type-box {
  padding: 10px 0;
  display: flex;
  justify-content: space-around;
  width: 100%;
}
</style>